import { flexRender, Cell } from "@tanstack/react-table";
import { TableCell } from "@mui/material";
import { twMerge } from "tailwind-merge";

import "ui/data-grid/data-grid.types";

type TableBodyCellProps<T> = {
  cell: Cell<T, unknown>;
  cellClassName?: string;
};

const ROW_ACTION_SX = { "& .MuiIconButton-root": { my: -1 } };

export const TableBodyCell = <T,>({ cell, cellClassName }: TableBodyCellProps<T>) => (
  <TableCell
    sx={ROW_ACTION_SX}
    className={twMerge("px-4 py-3", cellClassName, cell.column.columnDef.meta?.className)}>
    {flexRender(cell.column.columnDef.cell, cell.getContext())}
  </TableCell>
);
